import { render } from "./socialMedia.vue?vue&type=template&id=2b160f99&scoped=true"
import script from "./socialMedia.vue?vue&type=script&lang=js"
export * from "./socialMedia.vue?vue&type=script&lang=js"

import "./socialMedia.vue?vue&type=style&index=0&id=2b160f99&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b160f99"]])

export default __exports__